import _classCallCheck from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Deprecation = /*#__PURE__*/function (_Error) {
  _inherits(Deprecation, _Error);

  var _super = _createSuper(Deprecation);

  function Deprecation(message) {
    var _this;

    _classCallCheck(this, Deprecation);

    _this = _super.call(this, message); // Maintains proper stack trace (only available on V8)

    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    }

    _this.name = 'Deprecation';
    return _this;
  }

  return Deprecation;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { Deprecation };